import { Mail, Phone, MessageCircle, BarChart3, Send, Workflow, CalendarClock, Plug, Sparkles } from "lucide-react";
import { useLocale } from "@/i18n/detect";

const icons = [Mail, Phone, MessageCircle, Send, BarChart3, Workflow, CalendarClock, Plug, Sparkles];

const Features = () => {
  const { ui } = useLocale();
  const t = ui.features;
  return (
    <section id="features" className="py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">{t.eyebrow}</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            {t.title}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            {t.subtitle}
          </p>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {t.items.map((f, i) => {
            const Icon = icons[i] ?? Mail;
            return (
              <div
                key={f.title}
                className="group rounded-2xl border border-border bg-card p-7 shadow-card transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-elegant"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-gradient-primary group-hover:text-primary-foreground">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-5 font-display text-xl font-bold text-secondary">{f.title}</h3>
                <p className="mt-2 text-muted-foreground">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
